import { useEffect, useState } from "react";
import { readStorage, writeStorage } from "../lib/storage";

type Theme = "system" | "light" | "dark";
const KEY = "vads.theme";

export function applyStoredTheme(): void {
  const t = readStorage("local", KEY);
  if (t === "light" || t === "dark") document.documentElement.dataset.theme = t;
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => {
    const t = readStorage("local", KEY);
    return t === "light" || t === "dark" ? t : "system";
  });

  useEffect(() => {
    if (theme === "system") delete document.documentElement.dataset.theme;
    else document.documentElement.dataset.theme = theme;
    writeStorage("local", KEY, theme);
  }, [theme]);

  return (
    <label className="stack-sm xs">
      <span className="muted">Theme</span>
      <select className="select" value={theme} onChange={(e) => setTheme(e.target.value as Theme)}>
        <option value="system">Match system</option>
        <option value="light">Light</option>
        <option value="dark">Dark</option>
      </select>
    </label>
  );
}
